// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1311":"559a6cdf5e5a4a0a","2888":"05f74a32da399ed3"}[chunkId] + ".css";
};